import {
  Backdrop,
  Chip,
  FormControl,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef } from "react";

import "../../../../src/assets/css/material-dashboard_1.css";

import TestRadio from "./TestRadio";

import FormControlLabel from "@mui/material/FormControlLabel";

import { useState } from "react";
import TargettedSelect from "./TargettedSelect";
import BulkSelect from "./BulkSelect";
import Button from "@mui/material/Button";
import BulkSelect1 from "./BulkSelect1";
import { ThemeProvider, createTheme } from "@mui/material";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import NativePickers from "./ScheduleTimeDate";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import { common_axios } from "../../../App";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
// import Chip from "@mui/material/Chip";
// import { history } from "redux-first-router";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import TestRadio2 from "./TestRadio2";
import { findAllByDisplayValue } from "@testing-library/react";
import contactfile1 from "../../../file/voice_campaign.xlsx";
import { Link } from "react-router-dom";
import { dateFormatter } from "../../../helper/helper";
import moment from "moment";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import FilterTableCampaignVoiceUpload from "./FilterTableCampaignVoiceUpload";

export default function UploaddVoiceeCampaign() {
  const history = useHistory();

  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const closeshedule = useRef();

  const [expandedinter, setExpandedinter] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpandedinter(newExpanded ? panel : false);
  };
  function handleChange0(event) {
    setFile(event.target.files[0]);
  }
  const [RadioGroupValues, setRadioGroupValues] = useState();
  const [open, setOpen] = useState();
  const [file, setFile] = useState();

  // voice campaigm //
  const [voiceplan, setvoiceplan] = useState("");
  const [onVoiceChange, setonVoiceChange] = useState(false);
  const [TableOpen, setTableOpen] = useState(false);
  console.log("aga22--", onVoiceChange);

  const username = localStorage.getItem("usernamedisplayed");

  console.log("username", username);

  const [CampaignType, setCampaignType] = useState("");
  console.log("aga--", CampaignType);
  const [callerid, setcallerid] = useState("");
  const [prompt2, setprompt2] = useState("");
  const [prompt3, setprompt3] = useState("");
  const [disableNext, setdisableNext] = useState(true);
  const [disableNext1, setdisableNext1] = useState(true);
  const [disableNext2, setdisableNext2] = useState(true);
  const [checkicon1, setcheckicon1] = useState(false);
  const [checkicon2, setcheckicon2] = useState(false);
  const [checkicon3, setcheckicon3] = useState(false);
  const [list, setlist] = useState(null);
  const [list2, setlist2] = useState(null);
  const [FilesImage, setFilesImage] = useState(null);
  const [list3, setlist3] = useState(null);
  const [TargettedArray, setTargettedArray] = useState(null);
  const [bulkdata3, setbulkdata3] = useState(null);
  const [bulkdata4, setbulkdata4] = useState(null);
  const [bulkdata5, setbulkdata5] = useState(null);
  const [Olddata, setOlddata] = useState(null);
  const [CalleridArray, setCalleridArray] = useState(null);
  const [TransDTMFArray, setTransDTMFArray] = useState(null);
  const [PhonebookArray, setPhonebookArray] = useState(null);
  const [showtextsuccessofschedule, setshowtextsuccessofschedule] =
    useState(false);
  const [showtextsuccessofschedule1, setshowtextsuccessofschedule1] =
    useState(false);
  const [scheduleDate, setscheduleDate] = useState();
  const [pairdisable, setpairdisable] = useState(true);
  const [showpreview, setshowpreview] = useState({
    show_1: false,
    show_2: false,
    show_3: false,
    show_4: false,
  });
  const [voicearray, setvoicearray] = useState([]);
  const [showtable, setshowtable] = useState(false);
  const [instantshow, setinstantshow] = useState([{}]);
  const [audioname, setaudioname] = useState("");

  console.log("callerarray", audioname);

  // console.log("vashddddddd", Olddata);

  const [Radiosdisabled, setRadiosdisabled] = useState({
    textarea: true,
    bulk: true,
    bulk1: true,
    choose: true,
  });

  console.log("gggg", TransDTMFArray);

  const callbackSchedule = (child) => {
    setscheduleDate(child.target.value);
  };
  const [getAudioPaiers, setgetAudioPairs] = useState({});

  const [audioArray, setaudioArray] = useState([]);

  console.log("uploaddddd", audioArray);

  const handlechangeAudioF1 = async (e, filee) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0], filee);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      // setFilesImage(img);
      setonVoiceChange(false);
      audioArray.push(aud);

      // console.log(
      //   "In here",
      //   e.target.files,
      //   e.target.files.length,
      //   e.target.files.FileList
      // );

      // const getFile = [];
      // for (let indexx = 0; indexx < e.target.files.length; indexx++) {
      //   let element = e.target.files[indexx];
      //   console.log({ element, indexx });

      //   const objj = {
      //     filee: element,
      //     [`fileName`]: URL.createObjectURL(element),
      //   };

      //   await getFile.push(objj);
      // }

      // console.log("dhdhdhdh", getFile);
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setgetAudioPairs({ AudioVoice: objj });

      // setgetAudioF1({
      //   // ...file,
      //   filee: e.target.files[0],
      //   [`fileName`]: URL.createObjectURL(e.target.files[0]),
      // });

      // toast.success("uploaded", {
      //   theme: "colored",
      // });
      // alert("show 1");
      setshowpreview({
        show_1: true,
        show_2: false,
        show_3: false,
        show_4: false,
      });
    } else if (onVoiceChange == true) {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName").value = "";
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName").value = "";
    }
  };

  const handlechangeAudioF2 = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setgetAudioPairs({ PromptsVoice: objj });
      setonVoiceChange(false);
      audioArray.push(aud);

      setshowpreview({
        show_1: false,
        show_2: true,
        show_3: false,
        show_4: false,
      });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName1").value = "";
    }
  };
  const handleChangePrompt_pair = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setonVoiceChange(false);
      audioArray.push(aud);
      setgetAudioPairs({ PromptsVoice_1_1: objj });
      setshowpreview({
        show_1: false,
        show_2: false,
        show_3: true,
        show_4: false,
      });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName2").value = "";
    }
  };

  const handleChangePrompt_pair_2 = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setonVoiceChange(false);
      audioArray.push(aud);

      setgetAudioPairs({ PromptsVoice_1_2: objj });
      setshowpreview({
        show_1: false,
        show_2: false,
        show_3: true,
        show_4: false,
      });

      // toast.success("uploaded", {
      //   theme: "colored",
      // });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName3").value = "";
    }
  };

  const handleChangePrompt_pair_3 = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setgetAudioPairs({ PromptsVoice_2_1: objj });

      setonVoiceChange(false);
      audioArray.push(aud);
      setshowpreview({
        show_1: false,
        show_2: false,
        show_3: false,
        show_4: true,
      });

      // toast.success("uploaded", {
      //   theme: "colored",
      // });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName4").value = "";
    }
  };

  const handleChangePrompt_pair_3_1 = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setgetAudioPairs({ PromptsVoice_2_2: objj });

      setonVoiceChange(false);
      audioArray.push(aud);
      setshowpreview({
        show_1: false,
        show_2: false,
        show_3: false,
        show_4: true,
      });

      // toast.success("uploaded", {
      //   theme: "colored",
      // });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName5").value = "";
    }
  };
  const handleChangePrompt_pair_3_2 = (e) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", e.target.files[0]);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      const objj = {
        filee: e.target.files[0],
        [`fileName`]: URL.createObjectURL(e.target.files[0]),
      };

      setgetAudioPairs({ PromptsVoice_2_3: objj });

      setonVoiceChange(false);
      audioArray.push(aud);
      setshowpreview({
        show_1: false,
        show_2: false,
        show_3: false,
        show_4: true,
      });

      // toast.success("uploaded", {
      //   theme: "colored",
      // });
    } else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });

      document.getElementById("fileName6").value = "";
    }
  };

  const sendcampaign = async () => {
    try {
      setOpen(true);
      // alert("working");
      const resSend = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/voice-campaign/save`,
        {
          campaignCategory: voiceplan?.obdCategory,
          campaignType: CampaignType,
          callerId: callerid,
          voiceFile: Olddata?.label,
          uid: localStorage.getItem("UserId"),
          // sechduleDate: moment(new Date()).format("lll"),
          sechduleDate: new Date().toJSON().slice(0, 16),
        }
      );

      console.log("resSchedule", resSend);

      if (resSend.data.statusDescription.statusCode == 200) {
        // alert("phone");
        closeshedule.current?.click();
        toast.success(resSend.data.statusDescription.statusMessage, {
          theme: "colored",
        });
        setOpen(false);

        setshowtextsuccessofschedule1(true);
        // console.log("resPhonebook", resSchedule.data.listofUserGroup);
        // setPhonebookArray(resSchedule.data.listofUserGroup);
        // setTargettedArray(rescaller?.data?.responseObject);
      } else {
        setOpen(false);
        toast.error(resSend.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (voiceplan?.obdCategory == "" || CampaignType == "") {
      setcheckicon1(false);
      setdisableNext(true);
    } else {
      setcheckicon1(true);

      setdisableNext(false);
    }
  }, [voiceplan, CampaignType]);

  useEffect(() => {
    if (Olddata != null) {
      setcheckicon3(true);
      setdisableNext2(false);
    } else {
      setcheckicon3(false);
      setdisableNext2(true);
    }
  }, [Olddata]);

  React.useEffect(() => {
    if (TargettedArray != undefined) {
      const dataarray =
        TargettedArray &&
        TargettedArray?.map((e) => ({
          label: `${e.criteria_name}`,
          userid: `${e.uid}`,
        }));
      setbulkdata3(dataarray);
    } else {
      setbulkdata3([]);
    }
  }, [TargettedArray]);

  React.useEffect(() => {
    if (TransDTMFArray != undefined) {
      const dataarrayTranDTMF =
        TransDTMFArray &&
        TransDTMFArray?.map((e) => ({
          label: `${e.filename}`,
          pathname: `${e.downlaodUrl}`,
        }));
      setbulkdata4(dataarrayTranDTMF);
    } else {
      setbulkdata4([]);
    }
  }, [TransDTMFArray]);

  React.useEffect(() => {
    if (PhonebookArray != undefined) {
      const dataarrayPhonebook =
        PhonebookArray &&
        PhonebookArray?.map((e) => ({
          label: `${e.groupName}`,
          userid: `${e.groupName}`,
        }));
      setbulkdata5(dataarrayPhonebook);
    } else {
      setbulkdata5([]);
    }
  }, [PhonebookArray]);

  useEffect(() => {
    if (showtextsuccessofschedule1 == true) {
      setshowtextsuccessofschedule(false);
    } else if (showtextsuccessofschedule == true) {
      setshowtextsuccessofschedule1(false);
    }
  }, [showtextsuccessofschedule1, showtextsuccessofschedule1]);

  useEffect(() => {
    if (checkicon1 == true && checkicon2 == true && checkicon3 == true) {
      setpairdisable(false);
    } else {
      setpairdisable(true);
    }
    //  else if (showtextsuccessofschedule == true) {
    //   setpairdisable(true);
    // }
  }, [checkicon1, checkicon2, checkicon3]);

  const getvoiceplane = async () => {
    try {
      setOpen(true);
      // alert("working");
      const resvoice = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/obd-types`
      );

      console.log("resvoice", resvoice);

      if (resvoice.data.statusDescription.statusCode == 200) {
        console.log("ccc", resvoice.data.obdCategories);
        setOpen(false);
        setvoicearray(resvoice.data.obdCategories);
      } else {
        setOpen(false);
        toast.error(resvoice.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };
  console.log("hhhhhh", getAudioPaiers.PromptsVoice_1_1);
  useEffect(() => {
    getvoiceplane();
  }, []);

  const UploadAudioFile = async (e) => {
    e.preventDefault();
    setshowtable(false);
    // setinstantshow([]);
    if (CampaignType == "" || voiceplan?.id == undefined) {
      toast.error("Please Fill Voice plan or Campaign Type ", {
        theme: "colored",
      });
    } else {
      try {
        setOpen(true);
        const formData = new FormData();
        console.log("formm333", formData);
        // alert("working");
        // formData.append("file", FilesImage);
        for (var i = 0; i < audioArray.length; i++) {
          formData.append("file", audioArray[i]);
        }
        // formData.append("filename", audioname);
        const resSend = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/upload?obdType=${CampaignType}&categoryId=${voiceplan?.id}&username=${username}&prompt-name=${audioname}`,
          formData
        );

        console.log("resSchedule", resSend.data.obdCategory);

        if (resSend.data.statusDescription.statusCode == 200) {
          // alert("phone");
          // closeshedule.current?.click();
          toast.success(resSend.data.statusDescription.statusMessage, {
            theme: "colored",
          });

          console.log("arraylisfkshfi", resSend?.data?.obdCategory);
          // setinstantshow(resSend?.data?.obdFileUpload);
          // instantshow.push(resSend?.data?.obdRes);
          instantshow[0] = resSend?.data?.obdRes;

          setOpen(false);
          setshowtable(true);
          setshowpreview({
            show_1: false,
            show_2: false,
            show_3: false,
            show_4: false,
          });
          setaudioArray([]);
          setCampaignType(null);
          setvoiceplan(null);
          // setshowtextsuccessofschedule1(true);
          // console.log("resPhonebook", resSchedule.data.listofUserGroup);
          // setPhonebookArray(resSchedule.data.listofUserGroup);
          // setTargettedArray(rescaller?.data?.responseObject);
        } else {
          setOpen(false);
          toast.error(resSend.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        // alert("catch block");
        setOpen(false);
        console.log(error);
      }
    }
  };

  useEffect(() => {
    setshowpreview({
      show_1: false,
      show_2: false,
      show_3: false,
      show_4: false,
    });
    setaudioArray([]);
    setaudioname("");
  }, [CampaignType, voiceplan]);

  useEffect(() => {
    setCampaignType(null);
  }, [voiceplan]);

  useEffect(() => {
    if (audioArray.length == 0) {
      // alert("null");
      setdisableNext1(true);
    } else {
      // alert("fill");
      setdisableNext1(false);
    }
  }, [
    handleChangePrompt_pair_3_2,
    handleChangePrompt_pair_3_1,
    handleChangePrompt_pair_3,
    handleChangePrompt_pair_2,
    handleChangePrompt_pair,
    handleChangePrompt_pair,
    handlechangeAudioF2,
    handlechangeAudioF1,
  ]);
  // useEffect(() => {
  //   if (handleChangePrompt_pair_2 || handleChangePrompt_pair) {
  //     // alert("null");
  //     setdisableNext1(false);
  //   } else if (
  //     handleChangePrompt_pair_3 ||
  //     handleChangePrompt_pair_3_1 ||
  //     handleChangePrompt_pair_3_2
  //   ) {
  //     // alert("fill");
  //     setdisableNext1(false);
  //   }
  // }, [
  //   handleChangePrompt_pair_3_2,
  //   handleChangePrompt_pair_3_1,
  //   handleChangePrompt_pair_3,
  //   handleChangePrompt_pair_2,
  //   handleChangePrompt_pair,
  //   handlechangeAudioF2,
  //   handlechangeAudioF1,
  // ]);

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <div className="card-body">
            <section className="cmp">
              <div className="container-fluid">
                <div className="container-fluid_1">
                  {/* <!--marquee-section--> */}
                  <section className="marquee_8 modl">
                    <div className="d-flex justify-content-between">
                      <marquee>
                        Dear User !! There is an upgradation activity scheduled
                        on 30th January 2023 00:00Hrs to 31st January 2023 03:00
                        Hrs. All the operations will remain suspended during the
                        given time.
                      </marquee>
                    </div>
                  </section>
                  <div className="card mt-3">
                    <form
                      id="accord_8"
                      onSubmit={UploadAudioFile}
                      className="mt-4 m-0"
                      role="form"
                    >
                      {/* <div className="card-header p-3 pt-2">
                    <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                      <i className="material-icons opacity-10">person</i>
                    </div>
                    <div className="pt-1">
                      <p
                        className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                        style={{ marginLeft: "70px" }}
                      >
                        Voice File Approval
                      </p>
                      <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                        Field(s) marked with{" "}
                        <span className="text-danger fw-bold">*</span> are
                        mandatory.
                      </p>
                    </div>
                  </div> */}
                      {/* <div className="card shadow-none border bg_blue mt-5"> */}
                      <section className="modal_1">
                        <div className="card-body">
                          <div className="card shadow-none border bg_blue">
                            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                              Voice File Approval
                            </span>

                            <div className="card-body text-lg-start text-center">
                              <div className="row">
                                <div className="col-md-6 my-1">
                                  <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Voice Plan
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={voiceplan}
                                      onChange={(e) => {
                                        setvoiceplan(e.target.value);
                                        setonVoiceChange(true);
                                        // handleChangevoiceplan(e, data);
                                      }}
                                      autowidth
                                      label=" Voice Plan"
                                    >
                                      {voicearray &&
                                        voicearray?.map((data) => {
                                          // console.log("aaaa", data);

                                          return (
                                            <MenuItem value={data}>
                                              {data?.obdCategory}
                                            </MenuItem>
                                          );
                                        })}

                                      {/* <MenuItem value={"Transactional"}>
                                        Transactional
                                      </MenuItem> */}
                                      {/* <MenuItem value={"Promotional-30Sec"}>
                                        Promotional-30Sec
                                      </MenuItem>
                                      <MenuItem value={"Transactional-30Sec"}>
                                        Transactional-30Sec
                                      </MenuItem> */}
                                      {/* <MenuItem value={3}>3 Prompts OBD</MenuItem> */}
                                    </Select>
                                  </FormControl>
                                </div>

                                <div className="col-md-6 my-1">
                                  <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Campaign Type
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={CampaignType}
                                      onChange={(e) => {
                                        setCampaignType(e.target.value);
                                      }}
                                      // autowidth
                                      label="Campaign Type"
                                    >
                                      {/* {voiceplan.id == 1 ? ( */}
                                      {/* <> */}
                                      {voiceplan?.obdType &&
                                        voiceplan?.obdType?.map((data) => {
                                          return (
                                            <MenuItem value={data.id}>
                                              {data.obdType}
                                            </MenuItem>
                                          );
                                        })}
                                      {/* </>
                                      ) : (
                                        <></>
                                      )} */}
                                      {/* {voiceplan.id == 2 ? ( */}
                                      {/* <> */}
                                      {/* {voiceplan.obdType.map((data,index) => {
                                            return (
                                              <MenuItem key={index} value={data.id}>
                                                {data.obdType}
                                              </MenuItem>
                                            );
                                          })} */}
                                      {/* </>
                                      ) : (
                                        <></>
                                      )} */}

                                      {/* <MenuItem value="DTMF_1_Prompts">
                                        DTMF_1_Prompts
                                      </MenuItem>
                                      <MenuItem value="DTMF_2_Prompts">
                                        DTMF_2_Prompts
                                      </MenuItem>
                                      <MenuItem value="DTMF_3_Prompts ">
                                        DTMF_3_Prompts
                                      </MenuItem> */}
                                    </Select>
                                  </FormControl>
                                </div>

                                {(CampaignType == "1" ||
                                  CampaignType == "5") && (
                                  <>
                                    <div className="col-md-6 my-1">
                                      <TextField
                                        autoComplete="on"
                                        className="ms-4 w-50"
                                        type="text"
                                        label="Audio File Name"
                                        value={audioname}
                                        name="campaignname"
                                        variant="outlined"
                                        size="small"
                                        required
                                        onChange={(e) => {
                                          setaudioname(e.target.value);
                                        }}
                                        // value={formik.values.campaignname}
                                        // onBlur={formik.handleBlur}
                                        // error={
                                        //   formik.touched.campaignname &&
                                        //   Boolean(formik.errors.campaignname)
                                        // }
                                        // helperText={
                                        //   formik.touched.campaignname &&
                                        //   formik.errors.campaignname
                                        // }
                                      />
                                    </div>
                                  </>
                                )}

                                {(CampaignType == "2" ||
                                  CampaignType == "6") && (
                                  <>
                                    <div className="col-md-6 my-1">
                                      <TextField
                                        autoComplete="on"
                                        className="ms-4 w-50"
                                        type="text"
                                        label="Prompts Set Name"
                                        name="campaignname"
                                        value={audioname}
                                        variant="outlined"
                                        size="small"
                                        onChange={(e) => {
                                          setaudioname(e.target.value);
                                        }}
                                        required
                                        // onChange={formik.handleChange}
                                        // value={formik.values.campaignname}
                                        // onBlur={formik.handleBlur}
                                        // error={
                                        //   formik.touched.campaignname &&
                                        //   Boolean(formik.errors.campaignname)
                                        // }
                                        // helperText={
                                        //   formik.touched.campaignname &&
                                        //   formik.errors.campaignname
                                        // }
                                      />
                                    </div>
                                  </>
                                )}
                                {(CampaignType == "3" ||
                                  CampaignType == "7") && (
                                  <>
                                    <div className="col-md-6 my-1">
                                      <TextField
                                        autoComplete="on"
                                        className="ms-4 w-50"
                                        type="text"
                                        value={audioname}
                                        label="Prompt Set Name"
                                        name="campaignname"
                                        variant="outlined"
                                        size="small"
                                        required
                                        onChange={(e) => {
                                          setaudioname(e.target.value);
                                        }}
                                        // value={formik.values.campaignname}
                                        // onBlur={formik.handleBlur}
                                        // error={
                                        //   formik.touched.campaignname &&
                                        //   Boolean(formik.errors.campaignname)
                                        // }
                                        // helperText={
                                        //   formik.touched.campaignname &&
                                        //   formik.errors.campaignname
                                        // }
                                      />
                                    </div>
                                  </>
                                )}

                                {(CampaignType == "4" ||
                                  CampaignType == "8") && (
                                  <>
                                    <div className="col-md-6 my-1">
                                      <TextField
                                        autoComplete="on"
                                        className="ms-4 w-50"
                                        type="text"
                                        value={audioname}
                                        label="Prompt Set Name"
                                        onChange={(e) => {
                                          setaudioname(e.target.value);
                                        }}
                                        name="campaignname"
                                        variant="outlined"
                                        size="small"
                                        required
                                        // onChange={formik.handleChange}
                                        // value={formik.values.campaignname}
                                        // onBlur={formik.handleBlur}
                                        // error={
                                        //   formik.touched.campaignname &&
                                        //   Boolean(formik.errors.campaignname)
                                        // }
                                        // helperText={
                                        //   formik.touched.campaignname &&
                                        //   formik.errors.campaignname
                                        // }
                                      />
                                    </div>
                                  </>
                                )}
                              </div>

                              <div className="row my-3">
                                {/* <div className="text-end mt-3"> */}
                                {(CampaignType == "1" ||
                                  CampaignType == "5") && (
                                  <>
                                    {/* <div className="col-md-6">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-50"
                                    type="text"
                                    label="Audio File Name"
                                    value={audioname}
                                    name="campaignname"
                                    variant="outlined"
                                    size="small"
                                    required
                                    onChange={(e) => {
                                      setaudioname(e.target.value);
                                    }}
                                    // value={formik.values.campaignname}
                                    // onBlur={formik.handleBlur}
                                    // error={
                                    //   formik.touched.campaignname &&
                                    //   Boolean(formik.errors.campaignname)
                                    // }
                                    // helperText={
                                    //   formik.touched.campaignname &&
                                    //   formik.errors.campaignname
                                    // }
                                  />
                                </div> */}
                                    <div className="col-md-6 mt-3">
                                      <div
                                        class="input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold">
                                          Audio File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={getAudioF1.fileuplode}
                                            id="fileName"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            // onChange={(e) => {
                                            //   setgetAudioF1({
                                            //     ...getAudioF1,
                                            //     fileuplode: e.target.files[0],
                                            //   });
                                            // }}
                                            onChange={(e, filee) => {
                                              handlechangeAudioF1(e, filee);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                    </div>
                                    {showpreview.show_1 == true && (
                                      // <h1> audio 1</h1>

                                      <div className="col-md-6">
                                        <div className="d-flex align-items-center">
                                          <span className="d-block font-weight-bold">
                                            Preview Audio
                                          </span>

                                          <audio
                                            className="mt-2 ms-2"
                                            controls
                                            src={
                                              getAudioPaiers?.AudioVoice
                                                ?.fileName
                                            }
                                          >
                                            <a
                                              href={
                                                getAudioPaiers?.AudioVoice
                                                  ?.fileName
                                              }
                                            >
                                              Download audio
                                            </a>
                                          </audio>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}

                                {(CampaignType == "2" ||
                                  CampaignType == "6") && (
                                  <>
                                    {/* <div className="col-md-6">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-50"
                                    type="text"
                                    label="Prompts Set Name"
                                    name="campaignname"
                                    value={audioname}
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => {
                                      setaudioname(e.target.value);
                                    }}
                                    required
                                    // onChange={formik.handleChange}
                                    // value={formik.values.campaignname}
                                    // onBlur={formik.handleBlur}
                                    // error={
                                    //   formik.touched.campaignname &&
                                    //   Boolean(formik.errors.campaignname)
                                    // }
                                    // helperText={
                                    //   formik.touched.campaignname &&
                                    //   formik.errors.campaignname
                                    // }
                                  />
                                </div> */}
                                    <div className="col-md-6 mt-3">
                                      <div
                                        class="  input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold m-1">
                                          Prompt1 File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={Files}
                                            id="fileName1"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handlechangeAudioF2(e);
                                            }}
                                          />
                                        </Button>
                                        {/* <span className="d-block font-weight-bold"> */}
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                    </div>
                                    {showpreview.show_2 == true && (
                                      <div className="col-md-6">
                                        <div className="d-flex align-items-center">
                                          <span className="d-block font-weight-bold">
                                            Preview Audio
                                          </span>

                                          <audio
                                            className="mt-2 ms-2"
                                            controls
                                            src={
                                              getAudioPaiers?.PromptsVoice
                                                ?.fileName
                                            }
                                          >
                                            <a
                                              href={
                                                getAudioPaiers?.PromptsVoice
                                                  ?.fileName
                                              }
                                            >
                                              Download audio
                                            </a>
                                          </audio>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                                {(CampaignType == "3" ||
                                  CampaignType == "7") && (
                                  <>
                                    {/* <div className="col-md-6">
                                  <TextField
                                    autoComplete="on"
                                    className="ms-4 w-50"
                                    type="text"
                                    value={audioname}
                                    label="Prompt Set Name"
                                    name="campaignname"
                                    variant="outlined"
                                    size="small"
                                    required
                                    onChange={(e) => {
                                      setaudioname(e.target.value);
                                    }}
                                    // value={formik.values.campaignname}
                                    // onBlur={formik.handleBlur}
                                    // error={
                                    //   formik.touched.campaignname &&
                                    //   Boolean(formik.errors.campaignname)
                                    // }
                                    // helperText={
                                    //   formik.touched.campaignname &&
                                    //   formik.errors.campaignname
                                    // }
                                  />
                                </div> */}
                                    <div className="col-md-6 mt-3">
                                      <div
                                        class="  input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold m-1">
                                          Prompt1 File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            required
                                            // value={Files}
                                            id="fileName2"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handleChangePrompt_pair(e);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                      <div
                                        class="  input-group m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold">
                                          Prompt2 File
                                        </span>
                                        <Button
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={Files}
                                            id="fileName3"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handleChangePrompt_pair_2(e);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                    </div>
                                    {showpreview.show_3 == true && (
                                      <>
                                        {/* <div className="col-md-6"> */}

                                        {/* </div> */}
                                        <div className="col-md-6">
                                          <div className="d-flex align-items-center">
                                            <span className="d-block font-weight-bold">
                                              Preview Audio
                                            </span>

                                            <audio
                                              className="mt-2 ms-2"
                                              controls
                                              src={
                                                getAudioPaiers?.PromptsVoice_1_1
                                                  ?.fileName
                                              }
                                            >
                                              <a
                                                href={
                                                  getAudioPaiers
                                                    ?.PromptsVoice_1_1?.fileName
                                                }
                                              >
                                                Download audio
                                              </a>
                                            </audio>
                                          </div>
                                          <div className="d-flex align-items-center mt-5">
                                            <span className="d-block font-weight-bold">
                                              Preview Audio
                                            </span>

                                            <audio
                                              className="mt-2 ms-2"
                                              controls
                                              src={
                                                getAudioPaiers?.PromptsVoice_1_2
                                                  ?.fileName
                                              }
                                            >
                                              <a
                                                href={
                                                  getAudioPaiers
                                                    ?.PromptsVoice_1_2?.fileName
                                                }
                                              >
                                                Download audio
                                              </a>
                                            </audio>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                                {(CampaignType == "4" ||
                                  CampaignType == "8") && (
                                  <>
                                    <div className="col-md-6 mt-3">
                                      <div
                                        class="  input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold m-1">
                                          Prompt1 File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={Files}
                                            id="fileName4"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handleChangePrompt_pair_3(e);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                      <div
                                        class="  input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold m-1">
                                          Prompt2 File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={Files}
                                            id="fileName5"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handleChangePrompt_pair_3_1(e);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                      <div
                                        class="  input-group align-items-center m-0 mb-3"
                                        id="input_group_8"
                                      >
                                        <span className="d-block font-weight-bold m-1">
                                          Prompt3 File
                                        </span>
                                        <Button
                                          className="m-1"
                                          //   disabled={Radiosdisabled.choose}
                                          variant="contained"
                                          component="label"
                                          style={{
                                            backgroundColor: "white",
                                            //   boxShadow: "none",
                                            //   height: "40px",
                                            //   border: "1px solid #d2d6da",
                                            //   padding: "0px 0px 0px 0px",
                                            //   margin: "0px -3px 0px 0px",
                                            // color: "white",
                                          }}
                                        >
                                          <input
                                            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            // required={RadioGroupValues == 4}
                                            required
                                            // value={Files}
                                            id="fileName6"
                                            type="file"
                                            style={{
                                              color: "#7b809a",
                                            }}
                                            onChange={(e) => {
                                              handleChangePrompt_pair_3_2(e);
                                            }}
                                          />
                                        </Button>
                                        <span className="d-block w-100 text-center m-1">
                                          (File Format - *.wav , Max Size : 20MB
                                          )
                                        </span>
                                      </div>
                                    </div>
                                    {showpreview.show_4 == true && (
                                      <>
                                        <div className="col-md-6">
                                          {/* <div className="d-flex"> */}
                                          {/* <span className="d-block font-weight-bold">
                                          Preview Audio
                                        </span> */}
                                          {/* <div className="w-100 ms-2"> */}
                                          <div className="d-flex align-items-center">
                                            <span className="d-block font-weight-bold">
                                              Preview Audio
                                            </span>

                                            <audio
                                              className="mt-2 ms-2"
                                              controls
                                              src={
                                                getAudioPaiers?.PromptsVoice_2_1
                                                  ?.fileName
                                              }
                                            >
                                              <a
                                                href={
                                                  getAudioPaiers
                                                    ?.PromptsVoice_2_1?.fileName
                                                }
                                              >
                                                Download audio
                                              </a>
                                            </audio>
                                          </div>
                                          <div className="d-flex align-items-center my-5">
                                            <span className="d-block font-weight-bold">
                                              Preview Audio
                                            </span>

                                            <audio
                                              className="mt-2 ms-2"
                                              controls
                                              src={
                                                getAudioPaiers?.PromptsVoice_2_2
                                                  ?.fileName
                                              }
                                            >
                                              <a
                                                href={
                                                  getAudioPaiers
                                                    ?.PromptsVoice_2_2?.fileName
                                                }
                                              >
                                                Download audio
                                              </a>
                                            </audio>
                                          </div>
                                          <div className="d-flex align-items-center">
                                            <span className="d-block font-weight-bold">
                                              Preview Audio
                                            </span>

                                            <audio
                                              className="mt-2 ms-2"
                                              controls
                                              src={
                                                getAudioPaiers?.PromptsVoice_2_3
                                                  ?.fileName
                                              }
                                            >
                                              <a
                                                href={
                                                  getAudioPaiers
                                                    ?.PromptsVoice_2_3?.fileName
                                                }
                                              >
                                                Download audio
                                              </a>
                                            </audio>
                                          </div>
                                          {/* </div> */}
                                          {/* </div> */}
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                                {/* <button
                            disabled={disableNext1}
                            type="button"
                            // className="btn btn-success nx_pv m-0 opc_8"
                            className={
                              disableNext1
                                ? "btn btn-success nx_pv m-0 opc_8"
                                : "btn btn-success nx_pv m-0"
                            }
                            // onClick={smsDetailsSubmit}
                            // onClick={SecondNext}
                          >
                            Cancel
                            <ArrowRightAltRoundedIcon />
                          </button> */}
                                {/* </div> */}
                              </div>
                              <button
                                type="submit"
                                disabled={disableNext1}
                                className={
                                  disableNext1
                                    ? "btn btn-success opc_8 m-0 d-block ms-auto "
                                    : "btn btn-success m-0 d-block ms-auto "
                                }
                                // onClick={UploadAudioFile}
                              >
                                Save{" "}
                              </button>

                              <div className="text-end me-3 mb-3 mt-3">
                                <p>View My Voice Files</p>
                                <Link
                                  to="/dashboard/MyVoiceFiles"
                                  style={{
                                    color: "#63B7E6",
                                    marginLeft: "30px",
                                  }}
                                >
                                  <span>Click here !!!</span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </form>

                    {showtable == true && (
                      <section
                        className="sms_form mt-1"
                        style={{
                          boxShadow: "0px 1px 6px #00000091",
                          borderRadius: "20px",
                          /* margin-top: 53px; */
                          paddingBottom: "20px",
                        }}
                      >
                        <div className="flt_start">
                          <div className="float-start d-flex align-items-center flex-wrap"></div>
                        </div>
                        {/* {checkicon1 == true && checkicon2 == true && checkicon3 == true ?(<></>):(<></>)} */}
                        <div className="d-flex justify-content-center align-items-center mt-4">
                          <FilterTableCampaignVoiceUpload
                            showtable={showtable}
                            instantshow={instantshow}
                          />
                        </div>
                      </section>
                    )}

                    <section className="modal_1">
                      {/* <!-- Button trigger modal --> */}
                      {/* <!-- <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  Launch demo modal
              </button> --> */}

                      {/* <!-- Modal --> */}
                      <div
                        className="modal fade"
                        id="exampleModal51"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                Test Campaign
                              </h5>
                              <button
                                type="button"
                                className="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <TextField
                                autoComplete="on"
                                className="ms-4 w-50"
                                type="text"
                                label="Target Test Number"
                                // name="campaignname"
                                variant="outlined"
                                size="small"
                                required
                                // onChange={formik.handleChange}
                                // value={formik.values.campaignname}
                                // onBlur={formik.handleBlur}
                                // error={
                                //   formik.touched.campaignname &&
                                //   Boolean(formik.errors.campaignname)
                                // }
                                // helperText={
                                //   formik.touched.campaignname &&
                                //   formik.errors.campaignname
                                // }
                              />
                            </div>

                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary m-0"
                                data-bs-dismiss="modal"
                              >
                                ok
                              </button>
                              {/* <button
                                type="button"
                                className="btn btn-primary m-0 ms-2"
                              >
                                Save changes
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ----------schedule sms later---------- */}
                      <div
                        className="modal fade"
                        id="exampleModal1"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title text-capitalize"
                                id="exampleModalLabel"
                              >
                                schedule sms later
                              </h5>
                              <button
                                type="button"
                                className="btn-close m-0 p-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              {/* <NativePickers parentCallback={callbackSchedule} /> */}
                              <TextField
                                id="datetime-local"
                                size="small"
                                label="Select Schedule"
                                type="datetime-local"
                                // defaultValue="2017-05-24T10:30"
                                // defaultValue={new Date()}
                                onChange={(e, value) => {
                                  callbackSchedule(e, value);
                                }}
                                sx={{ width: 250 }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary m-0"
                                data-bs-dismiss="modal"
                                ref={closeshedule}
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary m-0 ms-2"
                                // onClick={scheduleapi}
                              >
                                Submit Campaign
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
